import FileAPI from "api/FileAPI";
import useFetchData from "hooks/useFetchData";

export default function useFileShareInfo( id?: string ) {
    return useFetchData({
        APIMethod: FileAPI.getShareInfo,
        params: [ id ],
        condition: !!id
    })
}